import {
    ArrowRight,
    Cloud,
    Database,
    FileText,
    Lock,
    Shield,
} from "lucide-react";
import {
    SectionEyebrow,
    SecurityTile,
} from "@/components/Landing/primitives";

const SECURITY_TILES = Object.freeze([
    {
        id: "hosting",
        icon: Cloud,
        title: "Hosted in Australia",
        body: "Data hosted in Australia on enterprise cloud infrastructure.",
    },
    {
        id: "iso",
        icon: Shield,
        title: "ISO 27001 Certified (JASANZ)",
        body: "Independently certified information security management system.",
    },
    {
        id: "sso",
        icon: Lock,
        title: "SSO, SCIM, RBAC, audit",
        body: "SSO, SCIM, role-based access control, full audit logging.",
    },
    {
        id: "residency",
        icon: Database,
        title: "Residency and retention",
        body: "Data residency, retention, and deletion controls aligned to enterprise procurement requirements.",
    },
]);

export default function Security({ onCapability }) {
    return (
        <section
            id="security"
            className="relative py-24 sm:py-32 bg-[#0A0A0A] text-white border-t border-white/5"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl reveal">
                    <SectionEyebrow>Security and trust</SectionEyebrow>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[1] mt-3">
                        Enterprise security from day one.
                    </h2>
                </div>

                <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
                    {SECURITY_TILES.map((t) => (
                        <SecurityTile
                            key={t.id}
                            icon={t.icon}
                            title={t.title}
                            body={t.body}
                        />
                    ))}
                </div>

                <div className="mt-10 rounded-2xl border border-white/10 bg-white/[0.03] p-6 sm:p-7 flex flex-col sm:flex-row items-start sm:items-center gap-5 reveal">
                    <FileText className="w-7 h-7 text-[#1FA8FF] shrink-0" />
                    <p className="text-zinc-300 text-[15px] leading-relaxed">
                        Procurement-ready vendor pack available on request,
                        including security questionnaire responses, insurance
                        certificates, and standard MSA.
                    </p>
                    <button
                        onClick={onCapability}
                        className="ml-auto inline-flex items-center gap-2 px-5 py-3 rounded-lg border border-white/20 hover:bg-white/5 text-white text-sm font-semibold whitespace-nowrap"
                    >
                        Request vendor pack
                        <ArrowRight className="w-4 h-4" />
                    </button>
                </div>
            </div>
        </section>
    );
}
